import { AvailabilityErrorTypeEnum } from '@sola/schema/dotcom/shared/am/errors.ts';

import { UserError } from '../errors-user.ts';

export const userErrorAvailabilityGeneric = (
  args: Omit<Partial<UserError>, 'type'> = {},
) =>
  new UserError({
    type: AvailabilityErrorTypeEnum.Generic,
    statusCode: args.statusCode ?? 400,
    data: args,
  });

// TODO: Determine how we want to differentiate this error from the userErrorCartHold errors
//       One thought is that we could use these errors specifically to refer to *communication*
//       issues instead of actual hold issues
export const userErrorAvailabilityHold = ({
  globalId,
  statusCode,
}: {
  globalId?: string;
  statusCode?: number;
}) =>
  new UserError({
    type: AvailabilityErrorTypeEnum.ChildHold,
    statusCode: statusCode ?? 400,
    data: {
      ...(globalId && { globalId }),
    },
  });
